import React from "react";
import Filter from "@radarly/components/filterbar/panels/classification/filter";
import {
  ClassificationFilter,
  ClassificationFilters,
} from "@radarly/models/filters";
import { getLevelFilters, isSelected } from "./utils";

interface IProps {
  filters: ClassificationFilters;
  level: number;
  onChangeLevel: (level: number, id: string) => void;
  onChangeStatus: (
    filter: ClassificationFilter,
    status: string,
    level: number
  ) => void;
  currentFilter: string;
  maxLevel?: number;
  children: React.ReactNode;
}

const FilterbarPanelsClassificationSublevel = ({
  filters,
  level,
  onChangeLevel,
  onChangeStatus,
  currentFilter,
  maxLevel = 3,
  children,
}: IProps) => {
  const levelFilters = getLevelFilters(filters, currentFilter, level);
  return (
    <>
      {levelFilters.length > 0
        ? levelFilters.map((filter) => (
            <Filter
              key={filter.id}
              filter={filter}
              subfilters={filter.subfilters}
              onClickFilter={() => onChangeLevel(level, filter.id)}
              onChange={(status) => onChangeStatus(filter, status, level)}
              hasChevron={level < maxLevel && !!filter.children}
              selected={isSelected(filter.id, currentFilter, level)}
            />
          ))
        : children}
    </>
  );
};

export default FilterbarPanelsClassificationSublevel;
